'use strict';

import {SectionCtrl} from "./sectionctrl.js";

export class SectionA42TimetableCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a4_2_timetable_before',
			on: false,
			value: null
		},
		after: {
			key: 'a4_2_timetable_after',
			on: false,
			value: null
		}
	};
	
	rows = [];
	timetable = {
		min: 1,
		max: 5,
		range: []
	};
	
	constructor($scope, $filter, jsDataService){
		super($scope, $filter, jsDataService);
		
		if(typeof(this.section.wp) !== 'undefined'){
			this.initWP(this.section.wp);
		}
		
	}
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
	
	initWP(workpackages){
		for(let wp of workpackages){
			this.rows.push(this.makeRowFromWp(wp));
			if(typeof(wp.activities) !== 'undefined'){
				for(let activity of Object.values(wp.activities)){
					this.rows.push(this.makeRowFromActivity(activity));
				}
			}
		}
		if(typeof(this.section.timeline) !== 'undefined'){
			if(typeof(this.section.timeline.min) !== 'undefined' && !isNaN(this.section.timeline.min)){
				this.timetable.min = parseInt(this.section.timeline.min);
			}
			if(typeof(this.section.timeline.max) !== 'undefined' && !isNaN(this.section.timeline.max)){
				this.timetable.max = parseInt(this.section.timeline.max);
			}
		}
		if(this.rows.length > 0){
			for(let nr=this.timetable.min; nr<=this.timetable.max; nr++){
				this.timetable.range.push(nr);
			}
		}
	}
	
	makeRowFromWp(wp){
		return {
			isWp: true,
			id: wp.id,
			number: wp.a4_1_work_activities_no,
			title: wp.a4_1_work_activities_name,
			start: parseInt(wp.a4_1_work_activities_start),
			end: parseInt(wp.a4_1_work_activities_end)
		};
	}
	
	makeRowFromActivity(activity){
		return {
			isWp: false,
			id: activity.id,
			number: activity.a4_1_work_activities_activ_no,
			title: activity.a4_1_work_activities_activ_name,
			start: parseInt(activity.a4_1_work_activities_activ_start),
			end: parseInt(activity.a4_1_work_activities_activ_end)
		};
	}
	/**
	 * 
	 * @param {rowObject} row
	 * @param {integer} nr
	 * @param {string} active - md-colors value for active cell
	 * @param {string} inactive - md-colors value for inactive cell
	 * @returns {string}
	 */
	getActiveCell(row, nr, active, inactive){
		if(row.start<=nr && row.end>=nr){
			return active;
		}
		return inactive;
	}
	
}

